import { Command } from 'commands/Commands';

export class DeleteBusinessAddress extends Command {
  type: string = 'DeleteBusinessAddress';
  priority = 100;
}